<!-- width={{ width }}px, height={{ height }}px -->

<canvas #pdf [width]="width" [height]="height"></canvas>
